import React from "react";
import moment from "moment";
import { Graph } from "../../components/Graph";

// ✅ Handle both date (`YYYY-MM-DD`) and time (`HH:mm`)
const formatTime = (time) => {
    if (!time) return ""; // Handle empty values

    // If it's in "HH:mm" format (e.g., "0:00", "1:00")
    if (/^\d{1,2}:\d{2}$/.test(time)) {
        return moment(time, "HH:mm").format("hh:mm A"); // Convert to "12:00 AM"
    }

    // If it's a date format (YYYY-MM-DD)
    if (moment(time, "YYYY-MM-DD", true).isValid()) {
        return moment(time).format("DD MMM"); // Convert "2025-01-26" → "26 Jan"
    }

    return time; // Return as is if it's unrecognized
};

const GraphSection = ({ visuals, isVisualsFetching }) => {
    const transformedData = visuals?.data
        ? [
              {
                  name: "Freemium Content",
                  data: visuals?.data?.map((item) => ({
                      x: formatTime(item?.time), // Handle different formats
                      y: item?.freemiumListeners
                  }))
              },
              {
                  name: "Premium Content",
                  data: visuals?.data?.map((item) => ({
                      x: formatTime(item?.time), // Handle different formats
                      y: item?.premiumListeners
                  }))
              }
          ]
        : [];

    return (
        <Graph
            graphType="line"
            height={370}
            data={transformedData}
            showFallback={false}
            isFetching={isVisualsFetching}
        />
    );
};

export default GraphSection;
